export const videoType = "video/mp4";
export const maxVideoSize = 30 * 1024 * 1024; // 30MB
